export { default as Consent } from './Consent';
export { default as consentReducer, updateConsentFromLink } from './consentSlice';
